import { DatePicker, DatePickerProps } from "antd";
import { InputLayout } from "../layouts";
import dayjs from "dayjs";

interface Props extends DatePickerProps {
  label?: string;
}
const Datepicker = ({ label, value, style, ...props }: Props) => {
  return (
    <InputLayout label={label} style={style}>
      <DatePicker
        {...props}
        className="w-full"
        value={!value ? undefined : dayjs(value)}
      />
    </InputLayout>
  );
};

export default Datepicker;
